import React from 'react';
import mobileHandover from '@ingka/ssr-icon/paths/mobile-handover';
import Button from 'ui/Button/Button';
import { ButtonTypeEnum } from 'ui/Button/Button';
import { useIntl } from 'react-intl';
import { isMobile } from 'utils/platform';
import { getKioskIntegration } from 'utils/integration';
import { useVpc } from 'hooks/useVpc';

const SaveForLaterButton = () => {
  const { formatMessage } = useIntl();
  const vpc = useVpc();
  const kioskIntegration = getKioskIntegration();

  const onClick = async () => {
    kioskIntegration.preSaveDesignForLater();
    const { vpcCode } = await vpc.save({ userTriggered: true });
    vpcCode && kioskIntegration.saveDesignForLater(vpcCode);
  };

  return (
    <Button
      style={{ pointerEvents: 'auto' }}
      ssrIcon={mobileHandover}
      inverseTheme={true}
      dataTestId="save-for-later-button"
      onClick={onClick}
      type={ButtonTypeEnum.primary}
      aria-label={formatMessage({ id: 'storageone.saveForLaterButton' })}
      text={formatMessage({ id: 'storageone.saveForLaterButton' })}
      size={isMobile() ? 'small' : 'medium'}
    />
  );
};

export default SaveForLaterButton;
